import { useQueryClient } from 'react-query';
import { queryKeys } from '../fax-queries';

export const useInvalidateFaxCount = () => {
  const queryClient = useQueryClient();

  return async () => {
    const countKey = [...queryKeys.base, 'count'];
    queryClient.invalidateQueries(countKey);
  };
};
